module.exports = __webpack_public_path__ + "img/5d4e07c.png";